import { FeatureToggleClientService } from 'feature-toggle-client';
import { GLOBAL_ACTIONS } from '../BuilderController';
export const RollbackBuilderVersion = 'rollback-builder-version';
export const UseTunnelOwnerContext = 'use-tunnel-owner-context';
export const StateExpiration = 'state-expiration';
export const ActionExecutionTimeout = 'action-execution-timeout';
export const OwnerIdentity = 'builder-owner-identity';
export const BuilderUndoRedoConfigurations = 'undo-redo-configurations';
export const BuilderConfigurationVariables = 'undo-redo-configurations-variables';
export const isSubflowImportExportEnabled = 'builder-subflow-import-export';
export const secretConfiguration = 'builder-secret-configuration-enabled';
export const configurationsApplicationsDomainUsageGet = 'use-configurations-domain-on-misc-operations-get';
export const configurationsApplicationsDomainUsageSet = 'use-configurations-domain-on-misc-operations-set';
export class BuilderConfigurationsSidebarFeatures {
    static isSubflowImportExportEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(isSubflowImportExportEnabled);
    }
    static isRollbackBuilderVersionEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(RollbackBuilderVersion);
    }
    static isGlobalActionsEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(GLOBAL_ACTIONS);
    }
    static isConfigurationVariablesEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(BuilderConfigurationVariables);
    }
    static isUseTunnelOwnerContextEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(UseTunnelOwnerContext);
    }
    static isStateExpirationEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(StateExpiration);
    }
    static isActionExecutionTimeoutEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(ActionExecutionTimeout);
    }
    static isOwnerIdentityEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(OwnerIdentity);
    }
    static isBuilderSecretConfigurationEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(secretConfiguration, false);
    }
    static isUseConfigurationsDomainOnMiscOperationsGetEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(configurationsApplicationsDomainUsageGet, false);
    }
    static isUseConfigurationsDomainOnMiscOperationsSetEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(configurationsApplicationsDomainUsageSet, false);
    }
}
